import { Injectable } from '@angular/core';
import {
    ApiService,
    EnvironmentModel, GenericOption,
    PaginatedRequest,
    PaginatedResponse
} from '@cas-hub/acabim-common-client';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ActionDisplayResponse, ActionRequest, ActionResponse, ActionTypeOptions, ActionTypes} from '../_models/action.model';
import {map} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ActionService extends ApiService {
    protected controller = 'action';

    constructor(
        protected client: HttpClient,
        protected environment: EnvironmentModel
    ) {
        super(client, environment);
    }

    public getActions(pagination?: PaginatedRequest): Observable<PaginatedResponse<ActionDisplayResponse>> {
        let params = new HttpParams();
        if (pagination) {
            params = pagination.getParams(params);
        }
        return this.client.get<PaginatedResponse<ActionResponse>>(this.url(''), {
            headers: this.defaultHeaders,
            params,
            responseType: 'json'
        }).pipe(map(data =>
            {
                const replacement = data.data.map(d => {
                    const newData: ActionDisplayResponse = {
                      ...d,
                      repeating_display: d.repeating > 0 ? 'True' : 'False',
                      status_display: d.status > 0 ? 'Active' : 'Archived',
                      entity_type_display: this.handleCase(d.entity_type),
                      entity_type_subset_display: this.handleCase(d.entity_type_subset),
                      target_type_display: this.handleCase(d.target_type)
                    }
                    return newData as ActionDisplayResponse;
                });
                data.data = replacement;
                return data as PaginatedResponse<ActionDisplayResponse>
            }
        ));
    }

    public addAction(payload: ActionRequest) {
        return this.client.post(this.url(''), payload, {
            headers: this.defaultHeaders,
            responseType: 'json'
        }).pipe(map(item => item));
    }

    public updateAction(actionId: number, payload: ActionRequest) {
        return this.client.post(this.url(actionId.toString()), payload, {
            headers: this.defaultHeaders,
            responseType: 'json'
        }).pipe(map(item => item));
    }

    public archiveAction(actionIds: number[]) {
        return this.client.delete(this.url(''), {
            body: actionIds,
            headers: this.defaultHeaders,
            responseType: 'json'
        }).pipe(map(item => item));
    }

    public getTypes(): Observable<ActionTypeOptions> {
        return this.client.get<ActionTypes>(this.url('types')).pipe(map(data => {
            const newTypes: ActionTypeOptions = {
                entityTypes: this.handleCaseArrays(data.entityTypes),
                entitySubTypes: this.handleCaseArrays(data.entitySubTypes),
                targetTypes: this.handleCaseArrays(data.targetTypes),
                categories: this.handleCaseArrays(data.categories),
                subCategories: this.handleCaseArrays(data.subCategories),
                expenseTypes: this.handleCaseArrays(data.expenseTypes)
            }
            return newTypes;
        }));
    }

    private handleCaseArrays(value: string[]): GenericOption[] {
        return  value.map(d => {
            const newD: GenericOption = {
                value: d,
                label: this.handleCase(d)
            }
            return newD;
        })
    }
    private handleCase(value: string): string {
        return value.replace(/([A-Z])/g, ' $1').replace(/^./, function(str){ return str.toUpperCase(); })
    }
}
